import {Component, Fragment, h} from "preact";
import {t} from "../../../_i18n";
import Summary from "../../../_common/components/Summary/summary";

export const ShowTerms = ({formative_zone, educationLaw, main}) => {
    const componentsMap = {
        CAT: {
            LOE: TermsLoeCat,
            LOGSE: TermsLogseCat,
            LOIFP: TermsLoifpCat
        },
        MAD: {
            LOE: TermsMad,
            LOGSE: TermsMad,
            LOIFP: TermsLoifpMad,
        }
    };

    const ComponentToRender = componentsMap[formative_zone]?.[educationLaw];

    return ComponentToRender && <ComponentToRender main={main} />;
}

const TermsLoeCat = ({main = false}) => (
  <div className='m-top t-justify'>
    <Summary title={t('Cálculo de la nota de las Unidades Formativas (LOE)')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_loe_cat_1')}}/>
    </Summary>
    <hr className="separator-xxs"/>
    <Summary title={t('Cálculo de la nota de los Módulos profesionales (LOE)')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_loe_cat_2')}}/>
    </Summary>
    <hr className="separator-xxs"/>
    <Summary title={t('Cálculo de la nota final del ciclo formativo (LOE)')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_loe_cat_3')}}/>
    </Summary>
    <hr className="separator-xxs"/>
  </div>
)

export const TermsLogseCat = ({main = false}) => (
  <div className='m-top t-justify'>
    <Summary title={t('Cálculo de la nota final de los módulos/créditos')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_logse_cat_1')}}/>
    </Summary>
    <hr className="separator-xxs"/>
    <Summary title={t('Cálculo de la nota final del ciclo formativo (LOGSE)')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_logse_cat_2')}}/>
    </Summary>
    <hr className="separator-xxs"/>
  </div>
)

export const TermsLoifpCat = ({main = false}) => (
    <div className='m-top t-justify'>
        <Summary title={t('Cálculo de la nota de los Resultados de Aprendizaje')} classNameTitle={main ? 'font-24' : 'font-18'}>
            <div dangerouslySetInnerHTML={{__html: t('terms_loifp_cat_1')}}/>
        </Summary>
        <hr className="separator-xxs"/>
        <Summary title={t('Cálculo de la nota de los Módulos profesionales')} classNameTitle={main ? 'font-24' : 'font-18'}>
            <div dangerouslySetInnerHTML={{__html: t('terms_loifp_cat_2')}}/>
        </Summary>
        <hr className="separator-xxs"/>
        <Summary title={t('Cálculo de la nota final del ciclo formativo')} classNameTitle={main ? 'font-24' : 'font-18'}>
            <div dangerouslySetInnerHTML={{__html: t('terms_loifp_cat_3')}}/>
        </Summary>
        <hr className="separator-xxs"/>
    </div>
)

export const TermsMad = ({main = false}) => (
  <div className='m-top t-justify'>
    <Summary title={t('Cálculo de la nota final de los módulos/créditos')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_mad_1')}}/>
    </Summary>
    <hr className="separator-xxs"/>
    <Summary title={t('Cálculo de la nota final del ciclo formativo')} classNameTitle={main ? 'font-24' : 'font-18'}>
      <div dangerouslySetInnerHTML={{__html: t('terms_mad_2')}}/>
    </Summary>
    <hr className="separator-xxs"/>
  </div>
)

export const TermsLoifpMad = ({main = false}) => (
    <div className='m-top t-justify'>
        <Summary title={t('Cálculo de la nota de los Resultados de Aprendizaje')}
                 classNameTitle={main ? 'font-24' : 'font-18'}>
            <div dangerouslySetInnerHTML={{__html: t('terms_loifp_mad_1')}}/>
        </Summary>
        <hr className="separator-xxs"/>
        <Summary title={t('Cálculo de la nota de los Módulos profesionales')}
                 classNameTitle={main ? 'font-24' : 'font-18'}>
            <div dangerouslySetInnerHTML={{__html: t('terms_loifp_mad_2')}}/>
        </Summary>
        <hr className="separator-xxs"/>
        <Summary title={t('Cálculo de la nota final del ciclo formativo')}
                 classNameTitle={main ? 'font-24' : 'font-18'}>
            <div dangerouslySetInnerHTML={{__html: t('terms_loifp_mad_3')}}/>
        </Summary>
        <hr className="separator-xxs"/>
    </div>
)
